angular.module("app").controller("CategoriesEditPageController", [
    '$scope',
    'preloadedData',
    'preloadedParents',
    'casinoCategoryService',
    'errorHandler',
    'logger',
    'pageStatuses',
    'deepCompare',
    function ($scope, preloadedData, preloadedParents, casinoCategoryService, errorHandler, logger, pageStatuses, deepCompare) {

        $scope.tooltip = {
            name: "",
            title: ""
        };

        $scope.pageStatuses = pageStatuses;

        $scope.save = function () {
            var requestData = {
                    casinoCategory: {}
                },
                changes;

            changes = deepCompare.getChanges(preloadedData.category, fetchData());
            changes.id = preloadedData.category.id;
            requestData.casinoCategory = changes;
            casinoCategoryService.edit(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("updated");
                        preloadedData.category = fetchData();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isAllowedToUpdate = function () {
            return deepCompare.isEqual(fetchData(), preloadedData.category)
        };

        function init () {
            $scope.categoryData = angular.copy(preloadedData.category);
            $scope.parents = angular.copy(preloadedParents.categories);
            $scope.parents.unshift({name: "No Parent", id: "0"});
            $scope.edit_category_form && $scope.edit_category_form.$setPristine();
        }

        function fetchData () {
            return angular.copy($scope.categoryData);
        }

        init();
    }
]);